<template>
  <section class='leaveStu' @click='hideInput'>
    <Form :model="formItem" :label-width="150" class='formDataCon'>
      <FormItem label="文章添加时间">
        <DatePicker type="datetimerange" format="yyyy-MM-dd" :split-panels='true' v-model='timerange' placeholder=""
          placeholder="默认查询当天" style="width: 100%" @on-change='getDates' />
      </FormItem>
      <FormItem label="文章点击数要求">
        <Input v-model="formItem.vewcnt" placeholder="文章访问量"></Input>
      </FormItem>
      <FormItem label="文章标题关键字">
        <Input v-model="formItem.title" placeholder="文章标题关键字"></Input>
      </FormItem>
      <FormItem label="所属栏目">
        <selftree :treedata='lanmu' :treekey="treekey" @click.stop='' :ischeck='true' :hideInputNum='hideInputNum'
          @changeClass='changeRenke' :isall='isall'></selftree>
      </FormItem>
      <FormItem label="添加人">
        <Input v-model="formItem.addusername" placeholder="请输入添加人"></Input>
      </FormItem>
      <FormItem label="编辑">
        <Input v-model="formItem.editor" placeholder="请输入编辑"></Input>
      </FormItem>
      <FormItem label="责任编辑">
        <Input v-model="formItem.owner" placeholder="请输入责任编辑"></Input>
      </FormItem>
      <Form-item prop="name" label="原创">
        <RadioGroup v-model="formItem.isoriginal">
          <Radio label="-1">全部</Radio>
          <Radio label="0">非原创</Radio>
          <Radio label="1">原创</Radio>
        </RadioGroup>
      </Form-item>
      <FormItem>
        <Button type="primary" @click='queryData'>查询</Button>
        <Button type="primary" style="margin-left: 22px" @click=exportData>导出</Button>
        <Button style="margin-left: 22px" @click='resetData'>重置</Button>
      </FormItem>
    </Form>
    <section>
      <p style='text-align:center;margin:10px auto;font-size:22px;'>共 {{ tableData.length }} 条</p>
      <Table border :columns="columns" :data="tableData"></Table>
    </section>
  </section>
</template>

<script>
import utils from '../utils/index'
import selftree from './inputTree'
export default {
  name: 'exportNews',
  components: {
    selftree
  },
  data () {
    return {
      lanmu: [],
      isall: 1,
      hideInputNum: -1,
      treekey: -1,
      formItem: {
        isoriginal: '-1',
        vewcnt: 1,
        begintime: '',
        endtime: '',
        addusername: '',
        editor: '',
        itemids: '',
        owner: '',
        title: '',
      },
      columns: [
        {
          title: '日期',
          key: 'showtime',
          render: (h, params) => {
            return h('span', params.row.showtime.split('.')[0])
          }
        },
        {
          title: '栏目',
          key: 'itemList',
          render: (h, params) => {
            return h('span', params.row.itemList.join('、'))
          }
        },
        {
          title: '标题',
          key: 'title'
        },
        {
          title: '作者',
          key: 'auther',
          width: 100,
        },
        {
          title: '编辑',
          key: 'editor',
          width: 100,
        },
        {
          title: '责任编辑',
          key: 'owner',
          width: 100,
        },
        {
          title: '阅读量',
          key: 'vewcnt',
          width: 100,
        },
        {
          title: '链接',
          key: 'guid',
          render: (h, params) => {
            // var url = this.baseURL.weburl2+'jwj/web.html?id='+params.row.guid+ '&token=' + localStorage.getItem('access_token')
            var _num = Math.random()

            _num = Math.floor(_num * 10000)
            var url = 'https://www.wjdaily.com/pcweb.html?timestamp=' + _num + '&id=' + params.row.guid
            return h('span', url)
          }
        },
      ],
      tableData: [],
      timerange: [],
      data: []
    }
  },
  mounted () {
    // 日期、栏目、标题、作者、编辑、责编、阅读量以及链接
  },
  methods: {
    changeRenke (val) {

      var arr = val['classid'].split(',')
      var newarr = []
      arr.map(function (val, index) {
        var vals = val.split('_')

        val = vals[vals.length - 1]

        newarr.push(val)
      })

      this.formItem.itemids = newarr.join(',')
    },
    hideInput (e) {

      this.hideInputNum = Math.random()
    },
    exportData () {
      // student/exportNoFace

      var tHeader = ["日期", "栏目", "标题", "作者", "编辑", "责任编辑", "阅读量", "链接"]
      var filterVal = ['showtime', 'itemList', 'title', 'auther', 'editor', 'owner', 'vewcnt', 'newsurl']
      var param = this.formItem
      utils.exportExcelPost('news/newsExport', param, '文章统计导出', tHeader, filterVal)
    },
    getDates (e) {
      console.log(e, 'e')
      this.formItem.begintime = e[0]
      this.formItem.endtime = e[1]
    },
    resetData () {
      this.timerange = []
      this.lanmu = []
      this.treekey = Math.random()
      this.formItem = {
        vewcnt: 1,
        begintime: '',
        endtime: '',
        addusername: '',
        editor: '',
        owner: '',
        title: '',
        isoriginal: '-1'
      }
    },
    queryData () {
      var that = this
      this.axios.post('news/newsExport', this.formItem).then(res => {
        console.log(res)

        if (res.data.lengtth == 0) {
          that.$Message.info('未查询到数据')
        } else {
          that.tableData = res.data
        }
      })
    }

  }
}
</script>

<style scoped>
.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.formDataCon {
  width: 800px;
  margin: 30px auto;
}
</style>
